import React from 'react';
import PortfolioCard from '../components/PortfolioCard';

export default function Portfolio() {
  return (
    <div>
      <PortfolioCard />
    </div>
  );
}
